<template>
    <div class="card card-height">
        <div class="table-container">
            <table class="table create-billing">
                <thead>
                    <tr>
                        <th class="col-particular">Item Details</th>
                        <th class="col-resource">Service Resource</th>
                        <th class="col-schedule">Schedule</th>
                        <th class="col-qty">Qty</th>
                        <th class="col-rate">Rate</th>
                        <th class="col-amount">Amount</th>
                        <th class="col-discount">Dis(%)</th>
                        <th class="col-damount">Dis</th>
                        <th class="col-after">After Disc.</th>
                        <th class="col-total">Total</th>
                        <th class="col-action"></th>
                    </tr>
                </thead>

                <tbody ref="tableRef">
                    <RowInline
                        v-for="(item, i) in tableItems" :key="i"
                        :item="item" :index="i"
                        @onOpenEditItem="onOpenEditItem"
                        @onDeleteItem="onDeleteItem"
                        @onOpenDentitionModal="onOpenDentitionModal"
                    />
                </tbody>
            </table>
            <p v-if="!tableItems.length" class="text-center mt-5 text-muted">No data</p>
        </div>
    </div>
</template>

<script setup>
import { ref } from 'vue';
import RowInline from './RowInline.vue';

const emit = defineEmits(['onOpenDentitionModal']);
const tableRef = ref(null);

const props = defineProps({
    tableItems: {
        type: Array,
        default: () => [],
    },
});

const onOpenDentitionModal = (item, index) => {
  emit('onOpenDentitionModal', item, index)
}

const onOpenEditItem = (index) => {
  props.tableItems[index].is_edit = true;
}

const onDeleteItem = (index) => {
    props.tableItems.splice(index, 1);
}

</script>

<style scoped>
/* ── Container ── */
.card-height {
    min-height: 200px;
}

.table-container {
    width: 100%;
    overflow: visible;         /* must not clip the AsyncSelect dropdown */
}

/* ── Table base ── */
.create-billing {
    table-layout: fixed;       /* prevents column width jitter */
    width: 100%;
    min-width: 960px;          /* ensures scroll kicks in before crushing */
    border-collapse: separate;
    border-spacing: 0;
}

/* ── Header ── */
.create-billing thead th {
    background-color: #f8f9fa;
    color: #6c757d;
    font-size: 0.75rem;
    font-weight: 600;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    padding: 0.65rem 0.5rem;
    border-bottom: 2px solid #dee2e6;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

/* ── Body cells ── */
.create-billing tbody td {
    padding: 0.55rem 0.5rem;
    vertical-align: middle;    /* keeps edit-mode rows (with inputs) aligned */
    border-bottom: 1px solid #f0f0f0;
    font-size: 0.875rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

/* Subtle hover highlight */
.create-billing tbody tr:hover td {
    background-color: #f5f7ff;
}

/* ── Column widths (add up to 100%) ── */
.col-particular  { width: 20%; text-align: left; }
.col-resource    { width: 14%; }
.col-schedule    { width: 14%; }
.col-qty         { width: 5%;  text-align: center; }
.col-rate        { width: 8%;  text-align: right; }
.col-amount      { width: 8%;  text-align: right; }
.col-discount    { width: 6%;  text-align: center; }
.col-damount     { width: 7%;  text-align: right; }
.col-after       { width: 9%;  text-align: right; }
.col-total       { width: 9%;  text-align: right; font-weight: 600; }
.col-action      { width: 4%;  text-align: center; }

/* ── Utility ── */
.table-totals {
    font-weight: bold;
}

/* Inputs inside edit rows stay full-width and compact */
.create-billing tbody td :deep(input),
.create-billing tbody td :deep(select) {
    width: 100%;
    padding: 0.25rem 0.4rem;
    font-size: 0.8rem;
}

/* Edit-row cells must not clip the AsyncSelect dropdown */
.create-billing tbody :deep(.tr-edit td) {
    overflow: visible;
}
</style>